export const skillsDE = {
  title:
    "Kurz gesagt, ich habe bereits Erfahrung mit diesen Tools und benutze sie häufig:",
  data: [
    "Python, JS/TS",
    "Django, FastAPI, Pandas",
    "React, Next.js",
    "Systemdesign, Architektur",
    "Docker, Kubernetes",
    "GitHub/GitLab CI/CD",
    "Linux, Nginx, DevOps Grundlagen",
    "AI-gestützte Entwicklung, Claude Code",
    "Integration von LLM-Features",
  ],
};
